// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parent Component Loader */

.e2e_loader_wrapper{
    width:100%;
    height:100%;
    min-height:220px;

    display:flex;
    align-items:center;
    justify-content:center;
}

/* Full Screen Loader */

.e2e_loader_fullpage{
  width: 100%;
    min-height:500px;
    background:#fff;
}

/* Loader */

.e2e_loader{
    position:relative;

    width:70px;
    height:70px;

    border:4px solid rgba(37,99,235,.12);
    border-top:4px solid #2563eb;

    border-radius:50%;

    animation:e2eRotate .9s linear infinite;
}

.e2e_loader::before{

    content:"";

    position:absolute;

    top:50%;
    left:50%;

    width:16px;
    height:16px;

    background:#2563eb;

    border-radius:50%;

    transform:translate(-50%,-50%);

    animation:e2ePulse 1.2s infinite;
}

.e2e_loader::after{

    content:"";

    position:absolute;

    width:10px;
    height:10px;

    border-radius:50%;

    background:#60a5fa;

    top:-5px;
    left:50%;

    transform:translateX(-50%);

    box-shadow:0 0 12px rgba(37,99,235,.5);
}

.e2e_loader_dot{

    position:absolute;

    width:10px;
    height:10px;

    border-radius:50%;

    background:#3b82f6;

    bottom:-5px;
    left:50%;

    transform:translateX(-50%);
}

@keyframes e2eRotate{

    from{
        transform:rotate(0deg);
    }

    to{
        transform:rotate(360deg);
    }

}

@keyframes e2ePulse{

    0%,100%{
        transform:translate(-50%,-50%) scale(.8);
        opacity:.6;
    }

    50%{
        transform:translate(-50%,-50%) scale(1.35);
        opacity:1;
    }

}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/loader.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;;IAEhB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,uBAAuB;;AAEvB;EACE,WAAW;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA,WAAW;;AAEX;IACI,iBAAiB;;IAEjB,UAAU;IACV,WAAW;;IAEX,oCAAoC;IACpC,4BAA4B;;IAE5B,iBAAiB;;IAEjB,uCAAuC;AAC3C;;AAEA;;IAEI,UAAU;;IAEV,iBAAiB;;IAEjB,OAAO;IACP,QAAQ;;IAER,UAAU;IACV,WAAW;;IAEX,kBAAkB;;IAElB,iBAAiB;;IAEjB,8BAA8B;;IAE9B,gCAAgC;AACpC;;AAEA;;IAEI,UAAU;;IAEV,iBAAiB;;IAEjB,UAAU;IACV,WAAW;;IAEX,iBAAiB;;IAEjB,kBAAkB;;IAElB,QAAQ;IACR,QAAQ;;IAER,0BAA0B;;IAE1B,sCAAsC;AAC1C;;AAEA;;IAEI,iBAAiB;;IAEjB,UAAU;IACV,WAAW;;IAEX,iBAAiB;;IAEjB,kBAAkB;;IAElB,WAAW;IACX,QAAQ;;IAER,0BAA0B;AAC9B;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA;;IAEI;QACI,wCAAwC;QACxC,UAAU;IACd;;IAEA;QACI,0CAA0C;QAC1C,SAAS;IACb;;AAEJ","sourcesContent":["/* Parent Component Loader */\r\n\r\n.e2e_loader_wrapper{\r\n    width:100%;\r\n    height:100%;\r\n    min-height:220px;\r\n\r\n    display:flex;\r\n    align-items:center;\r\n    justify-content:center;\r\n}\r\n\r\n/* Full Screen Loader */\r\n\r\n.e2e_loader_fullpage{\r\n  width: 100%;\r\n    min-height:500px;\r\n    background:#fff;\r\n}\r\n\r\n/* Loader */\r\n\r\n.e2e_loader{\r\n    position:relative;\r\n\r\n    width:70px;\r\n    height:70px;\r\n\r\n    border:4px solid rgba(37,99,235,.12);\r\n    border-top:4px solid #2563eb;\r\n\r\n    border-radius:50%;\r\n\r\n    animation:e2eRotate .9s linear infinite;\r\n}\r\n\r\n.e2e_loader::before{\r\n\r\n    content:\"\";\r\n\r\n    position:absolute;\r\n\r\n    top:50%;\r\n    left:50%;\r\n\r\n    width:16px;\r\n    height:16px;\r\n\r\n    background:#2563eb;\r\n\r\n    border-radius:50%;\r\n\r\n    transform:translate(-50%,-50%);\r\n\r\n    animation:e2ePulse 1.2s infinite;\r\n}\r\n\r\n.e2e_loader::after{\r\n\r\n    content:\"\";\r\n\r\n    position:absolute;\r\n\r\n    width:10px;\r\n    height:10px;\r\n\r\n    border-radius:50%;\r\n\r\n    background:#60a5fa;\r\n\r\n    top:-5px;\r\n    left:50%;\r\n\r\n    transform:translateX(-50%);\r\n\r\n    box-shadow:0 0 12px rgba(37,99,235,.5);\r\n}\r\n\r\n.e2e_loader_dot{\r\n\r\n    position:absolute;\r\n\r\n    width:10px;\r\n    height:10px;\r\n\r\n    border-radius:50%;\r\n\r\n    background:#3b82f6;\r\n\r\n    bottom:-5px;\r\n    left:50%;\r\n\r\n    transform:translateX(-50%);\r\n}\r\n\r\n@keyframes e2eRotate{\r\n\r\n    from{\r\n        transform:rotate(0deg);\r\n    }\r\n\r\n    to{\r\n        transform:rotate(360deg);\r\n    }\r\n\r\n}\r\n\r\n@keyframes e2ePulse{\r\n\r\n    0%,100%{\r\n        transform:translate(-50%,-50%) scale(.8);\r\n        opacity:.6;\r\n    }\r\n\r\n    50%{\r\n        transform:translate(-50%,-50%) scale(1.35);\r\n        opacity:1;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
